import React from "react"
import { Link } from "gatsby"
import FoodCategories from "./FoodCategories"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import PhoneIcon from "@material-ui/icons/Phone"

const RestaurantDetails = ({ details }) => {
  const {
    title,
    slug,
    allCitiessMetadata,
    allFoodTypessMetadata,
    restaurantACF,
    content,
  } = details

  const siteWeb = restaurantACF.siteWeb ? (
    <p className="mb-small">
      <strong>Site web : </strong>
      <a href={restaurantACF.siteWeb} target="_blank" rel="noreferrer">
        {restaurantACF.siteWeb}
      </a>
    </p>
  ) : null
  const pageFacebook = restaurantACF.pageFacebook ? (
    <p className="mb-small">
      <strong>Page Facebook : </strong>
      <a href={restaurantACF.pageFacebook} target="_blank" rel="noreferrer">
        {restaurantACF.pageFacebook}
      </a>
    </p>
  ) : null
  return (
    <article className="bg-primary padding height-100">
      <h2 className="h3 text-center mb-0">
        Informations sur le restaurant : {title}
      </h2>
      <FoodCategories cats={allFoodTypessMetadata} />
      <div className="flex-container mt-2 mb-1">
        <Link className="button primary-dark mr" to={`/#${slug}`}>
          <ArrowBackIcon />
          Retour aux restaurants
        </Link>
        <a href={`tel:${restaurantACF.phone}`} className="button primary-light">
          <PhoneIcon />
          Appeler
        </a>{" "}
      </div>
      <div className="mb-2">
        <h3 className="h5">
          Adresse: {restaurantACF.address} à {allCitiessMetadata.nodes[0].name}
        </h3>
        {siteWeb}
        {pageFacebook}
        <div className="content">
          <h3 className="h5">A propos de ce restaurant :</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          ></div>{" "}
          <h3 className="h5">
            La formule de ce restaurant est valable {restaurantACF.available}
          </h3>{" "}
          <h3 className="h5">Ouverture :</h3>
          <div>
            <strong className="day">Lundi : </strong>
            <span>{restaurantACF.opening.lundi}</span>
          </div>
          <div>
            <strong className="day">Mardi : </strong>
            <span>{restaurantACF.opening.mardi}</span>
          </div>
          <div>
            <strong className="day">Mercredi : </strong>
            <span>{restaurantACF.opening.mercredi}</span>
          </div>
          <div>
            <strong className="day">Jeudi : </strong>
            <span>{restaurantACF.opening.jeudi}</span>
          </div>
          <div>
            <strong className="day">Vendredi : </strong>
            <span>{restaurantACF.opening.vendredi}</span>
          </div>
          <div>
            <strong className="day">Samedi : </strong>
            <span>{restaurantACF.opening.samedi}</span>
          </div>
          <div>
            <strong className="day">Dimanche : </strong>
            <span>{restaurantACF.opening.dimanche}</span>
          </div>
        </div>
      </div>
    </article>
  )
}

export default RestaurantDetails
